import { useCallback, useEffect, useRef } from 'react'

interface UseOctadeskChatProps {
  hide?: boolean
}

export function useOctadeskChat({ hide = false }: UseOctadeskChatProps): null {
  const octadeskChatRef = useRef<HTMLElement | null>(null)

  const getOctadeskChatElement = useCallback(() => {
    if (!octadeskChatRef.current) {
      octadeskChatRef.current = document.querySelector('#octadesk-octachat-appchat')
    }
    return octadeskChatRef.current
  }, [])

  const hideOctadeskChat = useCallback(() => {
    const octadeskChatElement = getOctadeskChatElement() 
    if (octadeskChatElement) {
      octadeskChatElement.setAttribute('style', 'display: none !important')
    }
  }, [getOctadeskChatElement])

  const showOctadeskChat = useCallback(() => {
    const octadeskChatElement = getOctadeskChatElement()
    if (octadeskChatElement) {
      octadeskChatElement.setAttribute('style', 'display: block !important')
    }
  }, [getOctadeskChatElement])

  useEffect(() => {
    if (hide) {
      hideOctadeskChat()
    } else {
      showOctadeskChat()
    }

    return () => {
      showOctadeskChat()
    }
  }, [hideOctadeskChat, showOctadeskChat, hide])

  return null
}